export default __webpack_public_path__ + "static/NotoSerif-Regular-f137c7ae4fdb27744a29e3d78c9ff23d.ttf";